import { all, takeLatest, fork, put } from 'redux-saga/effects';
import OwnersApi from 'libs/api/owners';
import * as types from './types';
import UIHelper from '../../services/UIHelper';

const api = new OwnersApi();

function* getOwners({ payload }) {
  try {
    const { data } = yield api.getAccount(payload);
    const { owner } = data;
    yield put({
      type: types.OWNERS_GET_SUCCESS,
      payload: {
        ...(owner
          ? { ...owner, title: `${owner.first_name} ${owner.last_name}` }
          : {}),
      },
    });
  } catch (e) {
    yield put({
      type: types.OWNERS_GET_FAILURE,
      payload: e?.response,
    });
  }
}

function* createOrUpdate({ payload }) {
  try {
    const { id, formData, afterSuccess } = payload;
    const response = id
      ? yield api.put(id, { data: formData })
      : yield api.create({
          data: formData,
        });
    yield put({
      type: types.OWNERS_CREATE_OR_UPDATE_SUCCESS,
    });
    UIHelper.showCreateOrUpdateSuccess();
    afterSuccess && afterSuccess();
  } catch (e) {
    yield put({
      type: types.OWNERS_CREATE_OR_UPDATE_FAILURE,
      payload: e?.response?.data,
    });
  }
}

function* watchOwnersListRequest() {
  yield takeLatest(types.OWNERS_GET_REQUEST, getOwners);
}

function* watchOwnersCreateOrUpdateRequest() {
  yield takeLatest(types.OWNERS_CREATE_OR_UPDATE_REQUEST, createOrUpdate);
}

export default function* ownerSaga() {
  yield all([
    fork(watchOwnersListRequest),
    fork(watchOwnersCreateOrUpdateRequest),
  ]);
}
